export default __webpack_public_path__ + "apply1611f9b.png";